/*
 * A URL atual ja esta selada: useSealedSearchParams escreve o id do drawer
 * aberto em `?f=` antes deste componente renderizar. Reconstruir do zero com
 * especialista/estabelecimento em texto puro (como antes) furava o
 * selamento no proprio link compartilhado.
 */
const buildShareUrl = (referencedId?: string) => {
  if (!referencedId || typeof window === 'undefined') return undefined

  return window.location.href
}

export { buildShareUrl }
